module.exports = __webpack_public_path__ + "img/allerton_b3.62128666.jpg";